@if (showFooter()) {
    <app-bottom-sheet [menus]="menus()" />
}
